import { comparisonData, spreadsheetTable } from '@/mocks/content';

export default function ComparisonSection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-widest mb-3">
            Why Kakobuy Spreadsheet
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            How <span className="italic text-primary-500">Kakobuy Spreadsheet</span> Compares
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Feature comparison */}
          <div className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left py-3.5 px-5 text-sm font-heading font-bold text-foreground-900">Feature</th>
                  <th className="text-center py-3.5 px-5 text-sm font-heading font-bold text-primary-600">Kakobuy Spreadsheet</th>
                  <th className="text-center py-3.5 px-5 text-sm font-heading font-bold text-foreground-500">Other Resources</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, i) => (
                  <tr key={i} className={`border-b border-background-100 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                    <td className="py-3 px-5 text-sm text-foreground-700">{row.feature}</td>
                    <td className="py-3 px-5 text-center">
                      {row.kakobuy ? (
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-accent-100 text-accent-600">
                          <i className="ri-check-line text-sm"></i>
                        </span>
                      ) : (
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-foreground-100 text-foreground-400">
                          <i className="ri-close-line text-sm"></i>
                        </span>
                      )}
                    </td>
                    <td className="py-3 px-5 text-center">
                      {row.others ? (
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-accent-100 text-accent-600">
                          <i className="ri-check-line text-sm"></i>
                        </span>
                      ) : (
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-foreground-100 text-foreground-400">
                          <i className="ri-close-line text-sm"></i>
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Spreadsheet stats */}
          <div className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/70">
                  <th className="text-left py-3.5 px-5 text-sm font-heading font-bold text-foreground-900">Spreadsheet Category</th>
                  <th className="text-center py-3.5 px-5 text-sm font-heading font-bold text-foreground-900">Products</th>
                  <th className="text-center py-3.5 px-5 text-sm font-heading font-bold text-foreground-900">Price Level</th>
                  <th className="text-center py-3.5 px-5 text-sm font-heading font-bold text-foreground-900">Rating</th>
                </tr>
              </thead>
              <tbody>
                {spreadsheetTable.map((row, i) => (
                  <tr key={i} className={`border-b border-background-100 ${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}`}>
                    <td className="py-3 px-5 text-sm font-medium text-foreground-800">{row.category}</td>
                    <td className="py-3 px-5 text-center text-sm text-foreground-600">{row.products}</td>
                    <td className="py-3 px-5 text-center">
                      <span className="inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                        {row.priceLevel}
                      </span>
                    </td>
                    <td className="py-3 px-5 text-center text-sm font-semibold text-primary-600 whitespace-nowrap">{row.rating}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}